/**
 * Etiquetas y descripciones de los roles, en un único sitio.
 *
 * Antes vivían duplicadas en App.tsx y en Usuarios.tsx, y habían divergido: el
 * mismo rol se mostraba como «Agente» en el tooltip del avatar y como «Técnico»
 * en la pantalla de Usuarios. Con una sola fuente eso no puede repetirse.
 *
 * Los nombres INTERNOS son en inglés y genéricos de helpdesk (`agent`,
 * `requester`, migración f2b96d4c8a31); estas son las etiquetas que ve la
 * persona, en el vocabulario del CLAUDE.md: Técnico / Usuario (= quien reporta).
 */

export const ROLE_LABELS: Record<string, string> = {
  superadmin: 'Superadmin',
  admin: 'Administrador',
  coordinator: 'Coordinador',
  agent: 'Técnico',
  requester: 'Usuario',
};

export const ROLE_DESCRIPTIONS: Record<string, string> = {
  superadmin: 'Acceso total, incluida la edición de permisos por rol.',
  admin: 'Gestión completa: tickets, clientes, usuarios, equipos y categorías.',
  coordinator: 'Supervisa y gestiona el trabajo de su equipo. Puede asignar tickets.',
  agent: 'Atiende y actualiza el estado de los tickets asignados a su equipo.',
  requester: 'Abre tickets y sigue los suyos. Sin acceso al panel.',
};

/** Etiqueta de un rol, con el nombre interno como último recurso. */
export function roleLabel(name: string | null | undefined): string {
  if (!name) return '';
  return ROLE_LABELS[name] ?? name;
}
